import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PATH_DASHBOARD } from "../../routes/paths";
import axiosInstance from "../../utils/axios";

const initialState = {
  fetchLoading: false,
  isLoading: false,
  users: [],
};

export const createUser = createAsyncThunk(
  "createUser/user",
  async ({ data, enqueueSnackbar, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.post("users", data);
      enqueueSnackbar("User is added successfully");
      navigate(PATH_DASHBOARD.users.list);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchUsers = createAsyncThunk(
  "fetchUsers/user",
  async ({ enqueueSnackbar, filterStatus, search, role_id }, thunkApi) => {
    try {
      const response = await axiosInstance.get("users", {
        params: {
          tag_id: filterStatus,
          search,
          role_id,
        },
      });
      return {
        data: response.data.data.data,
        meta: {
          total: response.data.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// search user by phone
export const searchUserByPhone = createAsyncThunk(
  "searchUserByPhone/user",
  async ({ phone, enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.get("customers/live-search", {
        params: {
          phone,
        },
      });
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const updateUser = createAsyncThunk(
  "updateUser/user",
  async ({ id, data, enqueueSnackbar, setOpenEdit, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.put(`users/${id}`, data);
      await thunkApi.dispatch(fetchUsers({ enqueueSnackbar }));

      navigate(PATH_DASHBOARD.users.list);
      return {
        data: response.data.data,
        enqueueSnackbar,
        setOpenEdit,
        id,
        payload: data,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const deleteUser = createAsyncThunk(
  "deleteUser/user",
  async ({ id, enqueueSnackbar }, thunkApi) => {
    try {
      await axiosInstance.delete(`users/${id}`);
      return { id, enqueueSnackbar };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const userSlice = createSlice({
  name: "users",
  initialState,
  extraReducers: (builder) => {
    // TODO: create product
    builder.addCase(createUser.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createUser.fulfilled, (state) => {
      state.isLoading = false;
    });

    builder.addCase(createUser.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar(action.payload.error.message, {
          variant: "error",
        });
    });

    // ==========================

    // TODO: fetch product
    builder.addCase(fetchUsers.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchUsers.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.users = action.payload;
    });

    builder.addCase(fetchUsers.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar(action.payload.error.message, {
          variant: "error",
        });
    });

    // ==========================

    // TODO: update product
    builder.addCase(updateUser.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateUser.fulfilled, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar("User is updated successfully");

      // state.users.data = state.users.data.map((user) =>
      //   user.id === action.payload.id ? action.payload.data : user
      // );
      action.payload.setOpenEdit(false);
    });

    builder.addCase(updateUser.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: delete product
    builder.addCase(deleteUser.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteUser.fulfilled, (state, action) => {
      state.isLoading = false;
      state.users.data = state.users.data.filter(
        (product) => product.id !== action.payload.id
      );
      action.payload.enqueueSnackbar("User is deleted successfully");
    });

    builder.addCase(deleteUser.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================
  },
});

export default userSlice.reducer;
